export default __webpack_public_path__ + "static/approach-2-69b1f42b5d2c0e5410b7a622ccf74b93.svg";